import fetch from "../utils/fetch";
import {alertBackendError} from "../utils";

export const getJSONOrNull = async ({ url, doNotAlertErrors }) =>
{
    try {
        const response = await fetch( url );

        if (response.status === 200) {
            const content = await response.json();
            return content;
        }
        else
        {
            let errorText = await response.text();
            alertBackendError({ errorText, doNotAlertErrors });
            return null;
        }
    } catch ( exception ) {
        console.log(exception);
        alertBackendError({ exception, doNotAlertErrors });
        return null;
    }
};


// WEBPACK FOOTER //
// ./src/actions/OauthApplicationsActions.js